module.exports = __webpack_public_path__ + "static/media/winwin-8.jpeg";